import axios from "axios"
import axiosInstance from "../Interceptor"



export const getOrdersApi = (payload) => {
	 
	const prodUrl = process.env.REACT_APP_BASE_URL_TWO
     
	return (
		axiosInstance
			.get(`orders/api/v1/orders/regional_admin/?page=${payload}`)
			.then(function (response) {
			 
				return response
			})
			.catch((error) => {
			
				return error
			})
	)
}
